// extracted by mini-css-extract-plugin
export default {"storyDetail":"c-r_hl","storyDetail__photo":"c-r_hm"};